import React, { useEffect, useState } from 'react';
import { ArrowRight, PlayCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
// Interface to represent the last watched video
interface LastWatchedVideo {
  id: string;
  subjectId: string;
  subjectTitle: string;
  unitTitle: string;
  title: string;
  progress: number;
  timestamp: number;
}
export function CurrentTopic() {
  const navigate = useNavigate();
  const [lastWatched, setLastWatched] = useState<LastWatchedVideo | null>(null);
  // Fetch the last watched video from localStorage
  useEffect(() => {
    // Create an event listener to update the component when localStorage changes
    const handleStorageChange = () => {
      const storedLastWatched = localStorage.getItem('lastWatchedVideo');
      if (storedLastWatched) {
        setLastWatched(JSON.parse(storedLastWatched));
      }
    };
    // Initial fetch
    const storedLastWatched = localStorage.getItem('lastWatchedVideo');
    if (storedLastWatched) {
      setLastWatched(JSON.parse(storedLastWatched));
    } else {
      // If no last watched video exists, set a default one for demonstration
      const defaultLastWatched: LastWatchedVideo = {
        id: 'video-1',
        subjectId: 'turkce',
        subjectTitle: 'Türkçe',
        unitTitle: 'Sözcükte Anlam',
        title: 'Gerçek, Mecaz ve Terim Anlam',
        progress: 65,
        timestamp: 325 // 5:25 into the video
      };
      setLastWatched(defaultLastWatched);
      localStorage.setItem('lastWatchedVideo', JSON.stringify(defaultLastWatched));
    }
    // Add event listener for storage changes
    window.addEventListener('storage', handleStorageChange);
    // Custom event for same-window updates
    window.addEventListener('lastWatchedVideoUpdated', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('lastWatchedVideoUpdated', handleStorageChange);
    };
  }, []);
  // Handle the "Continue watching" button click
  const handleContinueWatching = () => {
    if (lastWatched) {
      // Navigate to the video page with the timestamp
      navigate(`/topics/${lastWatched.subjectId}/${lastWatched.unitTitle.toLowerCase().replace(/ /g, '-')}?video=${lastWatched.id}&t=${lastWatched.timestamp}`);
    } else {
      // If no last watched video, just navigate to the topics page
      navigate('/topics');
    }
  };
  return <div className="mb-6" data-id="element-231">
      <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-indigo-600 to-purple-600 group hover:shadow-[0_0_10px_rgba(255,255,255,0.2)] transition-all duration-300" data-id="element-232">
        <div className="relative p-6 bg-black/90 rounded-lg h-full" data-id="element-233">
          <div className="space-y-4" data-id="element-234">
            <h3 className="text-gray-400 font-medium text-sm" data-id="element-235">
              Devam Edilen Konu
            </h3>
            {lastWatched ? <>
                <div className="flex items-center" data-id="element-236">
                  <p className="text-3xl font-bold text-white" data-id="element-237">
                    {lastWatched.subjectTitle}
                  </p>
                  <PlayCircle className="ml-3 text-purple-400 w-8 h-8" data-id="element-238" />
                </div>
                <div className="space-y-1" data-id="element-239">
                  <p className="text-gray-200 text-lg font-medium" data-id="element-240">
                    {lastWatched.unitTitle}
                  </p>
                  <p className="text-gray-400 text-sm" data-id="element-241">{lastWatched.title}</p>
                </div>
                <div className="mt-4 space-y-2" data-id="element-242">
                  <div className="flex justify-between text-sm" data-id="element-243">
                    <span className="text-gray-400" data-id="element-244">İzleme İlerlemesi</span>
                    <span className="text-purple-400" data-id="element-245">
                      {lastWatched.progress}%
                    </span>
                  </div>
                  <div className="h-2 bg-gray-700 rounded-full overflow-hidden" data-id="element-246">
                    <div className="h-full bg-gradient-to-r from-purple-400 to-indigo-400 rounded-full" style={{
                  width: `${lastWatched.progress}%`
                }} data-id="element-247" />
                  </div>
                </div>
                <div className="flex justify-end mt-4" data-id="element-248">
                  <button onClick={handleContinueWatching} className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:from-purple-700 hover:to-indigo-700 transition-all" data-id="element-249">
                    Kaldığın Yerden Devam Et
                    <ArrowRight className="w-4 h-4" data-id="element-250" />
                  </button>
                </div>
              </> : <div className="text-center py-8" data-id="element-251">
                <p className="text-gray-400 mb-4" data-id="element-252">Henüz bir konu izlemediniz</p>
                <button onClick={() => navigate('/topics')} className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 mx-auto hover:from-purple-700 hover:to-indigo-700 transition-all" data-id="element-253">
                  Konuları Keşfet
                  <ArrowRight className="w-4 h-4" data-id="element-254" />
                </button>
              </div>}
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[rgba(255,255,255,0.1)] to-transparent group-hover:translate-x-full -skew-x-12 transition-transform duration-1000 ease-out" data-id="element-255" />
        </div>
      </div>
    </div>;
}